<div class="balance__filtrosGeneral">
    <div class="balance__filtroBuscar">
        <em class="fa fa-search iconPlaceholder"></em>
        <input class="balance__inputBuscar input-field" id="buscar" type="text" (keyup)="applyFilter($event)" placeholder="Buscar... " #input>
    </div>
</div>

<!-- COM Tabla Balance otros productos  ************************************************************************-->

<div class="balance__listado">
    <div class="mat-elevation-z8">
        <table mat-table aria-describedby="tabla Otros balance" [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="empresa">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Empresas</th>
                <td class="balance__margin" mat-cell *matCellDef="let row " [ngClass]="row?.semaforo === true ? 'ganancia'  :
                                                                                row?.semaforo === false  ? 'perdida' : ''"> {{row?.empresa}} </td>
            </ng-container>

            <ng-container matColumnDef="grupo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Grupos</th>
                <td class="balance__centerTd" mat-cell *matCellDef="let row "> {{row?.zona === null ? '- -' : row?.zona}} </td>
            </ng-container>
            ¿
            <ng-container matColumnDef="responsable">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Responsable</th>
                <td class="balance__centerTd" mat-cell *matCellDef="let row "> {{row?.responsable === null ? '- -' : row?.responsable}} </td>
            </ng-container>

            <ng-container matColumnDef="contacto">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Contacto</th>
                <td class="balance__centerTd" mat-cell *matCellDef="let row "> {{row?.contacto === null ? '- -' : row?.contacto}} </td>
            </ng-container>

            <ng-container matColumnDef="recarga">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Recargas</th>
                <td class="balance__centerTd" mat-cell *matCellDef="let row "> {{row?.recargas === null ? '$0' : row?.recargas | currency}} </td>
            </ng-container>

            <ng-container matColumnDef="factura">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Facturas</th>
                <td class="balance__centerTd" mat-cell *matCellDef="let row "> {{row?.facturas === null ? '$0' : row?.facturas | currency}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No hay datos que coincidan con el filtro o informaci&#243;n "{{input?.value}}"</td>
            </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 25, 100]" aria-label="Seleccione p&#225;gina"></mat-paginator>

    </div>
</div>